import "../../../css/voucher.css";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { MenuItem, Button } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import DescriptionComponent from "../../descriptionComponent";
import InputFileReader from "../../fileReader";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import NumberFormatCustom from "../../numberFormat";
import InputFormat from "../../../partials/inputForm";
import { getNumberOnString } from "../../../partials/validateNumber";
import LabelForm from "../../../partials/labelForm";
import SelectedBranch from "../../selectedBranch";
import { isJsonString } from "../../../utils/setting";
const styles = (theme) => ({
  paper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: theme.spacing(2),
  },
  card: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 500,
    maxWidth: 500,
  },
  media: {
    objectFit: "cover",
  },
  cardContent: {
    position: "absolute",
    paddingTop: 0,
  },
  nameSpa: {
    fontSize: 30,
    textTransform: "uppercase",
    fontWeight: 500,
    // letterSpacing: 8
  },
  textWhite: {
    color: "#fff",
  },
  address: {
    fontSize: 14,
    dispatch: "inline-block",
  },
  wrapperAddress: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    // borderBottom: '1px solid #ccc',
  },
  wrapperEndedDate: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  textRed: {
    color: "#ffb5ae",
  },
  endedDate: {
    fontSize: 14,
  },
  cardContentCode: {
    padding: 0,
    paddingBottom: 0,
    position: "absolute",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  wrapperCode: {
    padding: "10px 20px",
    borderBottomRightRadius: 20,
    borderTopRightRadius: 20,
    backgroundColor: "#FF513F",
    margin: "0",
  },
  code: {},
  discount: {
    fontSize: 16,
  },
  wrapperDiscount: {
    padding: "8px 20px",
    margin: "0",
  },
  wrapperQR: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: "10px 20px",
    fontSize: 28,
    color: "#fff",
    cursor: "pointer",
  },
  voucher: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  codeContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  textField: {
    width: "100%",
  },
  label: {
    fontSize: "1rem",
  },
  wrapButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  containerImage: {
    position: "relative",
    height: "25vw",
    width: "45vw",
    overflow: "hidden",
    border: "2px solid #F2F2F2",
    cursor: "pointer",
  },
  image: {
    width: "100%",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    // marginTop: `${theme.spacing(3)}px`,
  },
  customFormLabel: {
    display: "block",
    transformOrigin: "top left",
    transform: "translate(0, 1.5px) scale(0.75)",
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "500",
  },
  inputType: {
    height: "unset",
  },
});
const types = [
  {
    value: "percent",
    label: "Percent",
  },
  {
    value: "value",
    label: "Value",
  },
];
class MemberCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        forAll: 0,
        arrBranch: [], // Tránh TH record chưa có trường forAll và arrBranch do cập nhật db
        ...this.props.data,
      },
    };
  }
  getCode = (code) => {
    var arr = code.split("-");
    return arr[arr.length - 1];
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.type === "checkbox") {
      value = e.target.checked ? 1 : 0;
    }
    if (
      name == "expiredDays" ||
      name === "price" ||
      name === "value" ||
      name === "times"
    )
      value = getNumberOnString(value);
    let data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };
  changeArrBranch = (arrBranch) => {
    let data = this.state.data;
    data.arrBranch = JSON.stringify(arrBranch);
    this.setState(data);
  };
  handleSubComponentChange = (name, value) => {
    let data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };
  handleSubmitUpdate = async (data) => {
    data.type = data.type || "limited_all";
    let check = await this.props.updateMemberCard(data);
    this.loading.stopLoading();
    this.props.finishUpdate(check);
  };
  handleUploadImage = async () => {
    this.loading.startLoading();
    var { t } = this.props;
    var data = this.state.data;
    if (this.InputFileReader.getFile() !== null) {
      let check = await this.props.saveStorage({
        files: this.InputFileReader.getFile(),
        code: this.props.serviceCode,
        imgPre: "",
        type: "img-member-card",
      });
      if (check.code === 1) {
        data.image = check.data.previewLink;
        this.handleSubmitUpdate(data);
      } else {
        this.handleSubmitUpdate(data);
        this.mSnackbar.handleClick(
          t("membercard_add_upload_image_unsuccessfully") + " " + check.message,
          "warning"
        );
      }
    } else if (this.InputFileReader.getSrc() !== null) {
      data.image = this.InputFileReader.getSrc();
      this.handleSubmitUpdate(data);
    } else if (
      this.InputFileReader.getFile() === null &&
      data.image &&
      this.InputFileReader.getFlagEdit()
    ) {
      data.image = null;
      this.handleSubmitUpdate(data);
    } else {
      this.handleSubmitUpdate(data);
    }
  };
  handleCheck = () => {
    let memberCard = this.state.data;
    let { t } = this.props;
    if (!memberCard.title)
      this.mSnackbar.handleClick(
        t("membercard_add_please_add_title"),
        "warning"
      );
    else if (!memberCard.arrBranch.length && !memberCard.forAll)
      this.mSnackbar.handleClick(
        t("membercard_add_nothing_apply_branch"),
        "warning"
      );
    else if (!memberCard.price && !memberCard.value)
      this.mSnackbar.handleClick(
        t("membercard_add_please_add_price_value"),
        "warning"
      );
    else if (
      (memberCard.type === "limited_all" &&
        (!memberCard.value || !memberCard.times)) ||
      (memberCard.type === "limited_times" && !memberCard.times) ||
      (memberCard.type === "limited_money" && !memberCard.value)
    ) {
      this.mSnackbar.handleClick(
        t("membercard_add_please_fill_in_required"),
        "warning"
      );
    } else {
      this.handleUploadImage();
    }
  };
  render() {
    const { classes, t, listBranch } = this.props;
    const { data } = this.state;
    if (data.arrBranch && isJsonString(data.arrBranch))
      data.arrBranch = JSON.parse(data.arrBranch);
    const branch = data.arrBranch;
    let filterBranch = [];
    if (branch) {
      branch.forEach((e) => {
        let find = listBranch.find((i) => i.branchCode === e);
        if (find) {
          filterBranch.push(find);
        }
      });
    }
    return (
      <Paper className={classes.paper}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <InputFormat
              label={t("membercard_add_title")}
              name="title"
              fullWidth={true}
              required
              value={data.title}
              onChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputFormat
              required
              label={t("type")}
              name="type"
              select
              fullWidth={true}
              value={data.type}
              onChange={this.handleChange}
            >
              <MenuItem value={"limited_all"}>{t("limited_all")}</MenuItem>
              <MenuItem value={"limited_money"}>{t("limited_money")}</MenuItem>
              <MenuItem value={"limited_times"}>{t("limited_times")}</MenuItem>
              <MenuItem value={"unlimited_all"}>{t("unlimited_all")}</MenuItem>
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              disabled={data.type === "unlimited_all" ? true : false}
              required={
                data.type === "limited_times" || data.type === "limited_all"
                  ? true
                  : false
              }
              label={t("membercard_add_times")}
              name="times"
              value={
                !data.times ||
                (data.times && data.times === Number.MAX_SAFE_INTEGER)
                  ? ""
                  : data.times
              }
              onChange={this.handleChange}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              label={t("membercard_add_price")}
              name="price"
              fullWidth={true}
              value={data.price}
              onChange={this.handleChange}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              label={t("membercard_add_value")}
              name="value"
              fullWidth={true}
              disabled={data.type === "unlimited_all" ? true : false}
              required={
                data.type === "limited_money" || data.type === "limited_all"
                  ? true
                  : false
              }
              value={data.value}
              onChange={this.handleChange}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              // type="number"
              label={t("membercard_add_expiredDays")}
              name="expiredDays"
              value={
                !data.expiredDays ||
                (data.expiredDays &&
                  data.expiredDays === Number.MAX_SAFE_INTEGER)
                  ? ""
                  : data.expiredDays
              }
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              select
              label={t("membercard_add_isShow")}
              placeholder={t("pls_select")}
              value={data.isShow || 0}
              onChange={this.handleChange}
              name="isShow"
            >
              <MenuItem value={1}>{t("membercard_add_show")}</MenuItem>
              <MenuItem value={0}>{t("membercard_add_hide")}</MenuItem>
            </InputFormat>
          </Grid>
          {!data.forAll ? (
            <Grid item xs={12} sm={12}>
              <SelectedBranch
                onRef={(id) => (this.SelectedBranch = id)}
                multiple={true}
                required={true}
                handleChangeBranch={(arrBranch) =>
                  this.changeArrBranch(arrBranch)
                }
                disabled={data.forAll == 1}
                value={branch}
              />
            </Grid>
          ) : (
            ""
          )}
          <Grid item xs={12} sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={data.forAll == 1 ? true : false}
                  name="forAll"
                  onChange={this.handleChange}
                />
              }
              className={classes.label}
              label={t("membercard_add_all_branch")}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              label={t("membercard_add_shortDescription")}
              name="shortDescription"
              value={data.shortDescription}
              onChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <DescriptionComponent
              onRef={(id) => (this.DescriptionComponent = id)}
              title={t("membercard_cardmember_description")}
              handleSubComponentChange={this.handleSubComponentChange}
              description={data.description}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} style={{ paddingBottom: "0" }}>
            <LabelForm label={t("membercard_add_image")} />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <InputFileReader
              onRef={(id) => (this.InputFileReader = id)}
              style={classes}
              container="square"
              defaultImg={data.image || "/images/noneImage.svg"}
              selectStorageMode={true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} className={classes.wrapButton}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleCheck}
            >
              {t("membercard_add_save")}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

MemberCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({
  saveStorage: dispatch.upload.saveStorage,
  updateMemberCard: dispatch.memberCards.update,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(styles, { withTheme: true })(MemberCard))
);
